import { AgentMessage, AgentMessageType } from "@vertesia/common"

import { ChatMessageRoleType, Message } from "@models/messages"

export function initialMessage(content: string, runId: string, date?: number): AgentMessage {
    return {
        message: content,
        type: AgentMessageType.QUESTION,
        workflow_run_id: runId,
        timestamp: date || Date.now(),
    }
}

export function initialDetailedMessage(content: string, details: object | string, runId: string, date?: number): AgentMessage {
    return {
        message: content,
        type: AgentMessageType.QUESTION,
        workflow_run_id: runId,
        details: details,
        timestamp: date || Date.now(),
    }
}

export function generateMessage(content: string, runId: string, type: AgentMessageType, date?: number): AgentMessage {
    return {
        message: content,
        type: type,
        workflow_run_id: runId,
        timestamp: date || Date.now(),
    }
}

export function generateChatMessage(id: number, content: string, runId: string, type: ChatMessageRoleType, date?: Date): Message {
    return {
        id: id,
        content: content,
        role: type,
        timestamp: date || new Date(),
    }
}
